import React from 'react';
import { useIntl } from 'react-intl';
import { faPlay } from '@fortawesome/pro-solid-svg-icons/faPlay';
import { faPlus } from '@fortawesome/pro-light-svg-icons/faPlus';
import { TypedMemo } from '../../common/types';
import { SMLButton } from '../../common/views/SMLButton/SMLButton';
import { welcomeMessages as messages } from './welcomeMessages';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for the whole welcome page; each part uses its own slice of it */
import styles from './WelcomeView.module.scss';
/* eslint-enable css-modules/no-unused-class */

export interface WelcomeActionsProps {
  /** "Show me an example". Task 12 starts the tour here. */
  onExample: () => void;
  /** "Add my song" for an owner. */
  onAddSong?: () => void;
  /** "Open the workspace" for a member (design: onboarding a7). Replaces "Add my song". */
  onOpenWorkspace?: () => void;
  disabled: boolean;
  isBusy: boolean;
}

/** The two ways in (design: onboarding a1 `.ob-acts`, a7 for a member, a8 full width). */
const WelcomeActionsComponent: React.FC<WelcomeActionsProps> = ({
  onExample,
  onAddSong,
  onOpenWorkspace,
  disabled,
  isBusy,
}) => {
  const intl = useIntl();
  const isMember = onOpenWorkspace !== undefined;
  return (
    <>
      <div className={styles.actions}>
        {isMember ? (
          <>
            <SMLButton
              color="secondary"
              size="lg"
              omitCap
              onClick={onExample}
              disabled={disabled || isBusy}
              leftIcon={faPlay}
            >
              {intl.formatMessage(messages.example)}
            </SMLButton>
            <SMLButton color="secondary" outline size="lg" omitCap onClick={onOpenWorkspace} disabled={isBusy}>
              {intl.formatMessage(messages.memberOpen)}
            </SMLButton>
          </>
        ) : (
          <>
            {/* D8: the own song is the first way in; the demo is the second one. */}
            <SMLButton
              color="secondary"
              size="lg"
              omitCap
              onClick={onAddSong}
              disabled={disabled || isBusy}
              leftIcon={faPlus}
            >
              {intl.formatMessage(messages.addSong)}
            </SMLButton>
            <SMLButton
              color="secondary"
              outline
              size="lg"
              omitCap
              onClick={onExample}
              disabled={disabled || isBusy}
              leftIcon={faPlay}
            >
              {intl.formatMessage(messages.example)}
            </SMLButton>
          </>
        )}
      </div>
      {isMember ? null : <p className={styles.fine}>{intl.formatMessage(messages.exampleNote)}</p>}
    </>
  );
};

export const WelcomeActions = TypedMemo(WelcomeActionsComponent);
